import { gql } from "@apollo/client";

export const UpdateItemDetails = gql`
  mutation UpdateItemDetails(
    $token: String!
    $customerID: ID!
    $itemDetailsID: ID!
    $user_details: SubscribedUser!
    $input: UpdateStckItemDetails!
  ) {
    UpdateItemDetails(
      token: $token
      customerID: $customerID
      itemDetailsID: $itemDetailsID
      user_details: $user_details
      input: $input
    )
  }
`;
